import { useQuery } from "@tanstack/react-query";
import { CreateEmailTemplateRequest, emailtemplatesApi } from "api";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { queryClient } from "main";
import { PaziaLoader } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { useNavigate, useParams } from "react-router-dom";
import { useToaster } from "utils";
import { EmailPageHeader } from "../components/EmailPageHeader";
import { EmailTemplateForm } from "./EmailTemplateForm/EmailTemplateForm";

export const EditEmailTriggerPage = (): JSX.Element | null => {
  const { emailTemplateId } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.EMAIL_TEMPLATE(Number(emailTemplateId)),
    queryFn: () => emailtemplatesApi.fetchById(Number(emailTemplateId)),
    enabled: !!emailTemplateId,
  });

  if (isLoading) return <PaziaLoader position="center" />;
  if (!data?.data) return null;

  const isGeneric = data.data.type === 0;

  const breadcrumbs = [
    {
      title: isGeneric ? "Szablony" : "Wyzwalacze",
      path: routes.EMAILS + (isGeneric ? routes.EMAILS_TEMPLATES : routes.EMAILS_TRIGGERS),
    },
    { title: data.data.name },
  ];

  const onSubmit = async (formData: CreateEmailTemplateRequest) => {
    try {
      await emailtemplatesApi.update(data.data.id, formData);
      navigate(routes.EMAILS + (isGeneric ? routes.EMAILS_TEMPLATES : routes.EMAILS_TRIGGERS));
      showSuccess("Zaktualizowano szablon e-mail.");
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.EMAIL_TEMPLATE(Number(emailTemplateId)) });
    } catch (e) {
      showError("Wystąpił błąd podczas aktualizacji szablonu e-mail.");
      console.error(e);
    }
  };

  return (
    <div>
      <PaziaBreadcrumbs className="mb-2" segments={breadcrumbs} />
      <EmailPageHeader>Edytuj szablon e-mail</EmailPageHeader>
      <EmailTemplateForm onSubmit={onSubmit} template={data.data} isGeneric={isGeneric} />
    </div>
  );
};
